import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "partner-wrap style2 pb-100" }
const _hoisted_3 = { class: "row gx-5 align-items-center" }
const _hoisted_4 = { class: "col-xl-7 col-lg-6" }
const _hoisted_5 = { class: "partner-item-wrap" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-xl-5 col-lg-6" }, [
          _createElementVNode("div", { class: "partner-content" }, [
            _createElementVNode("div", { class: "content-title style1" }, [
              _createElementVNode("span", null, "Our Partner"),
              _createElementVNode("h2", null, "Our Trusted Partners Who Trust About Us"),
              _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting standard dummy text ever since the 1500. ")
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "partner-item",
                key: partner.id
              }, [
                _createElementVNode("img", {
                  src: partner.image,
                  alt: "Image"
                }, null, 8, _hoisted_6)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}